import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ACCOUNT } from '../../accounts';
import { TransactionsService } from '../../services/transactions.service';
import { DateRange, Transaction, TransactionType } from '@contracts/interfaces/transaction.interfaces';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { human } from 'src/app/tools/human-currency';

enum DateMode {
  Weekly,
  Monthly,
  Quaterly,
  Yearly
}

@Component({
  selector: 'app-revenue',
  templateUrl: './revenue.component.html',
  styleUrls: ['./revenue.component.scss', '../transaction-table.scss']
})
export class RevenueComponent implements OnInit {

  isLoading = true;
  human = human;

  dataSource: MatTableDataSource<Transaction>;

  dateMode: DateMode = DateMode.Weekly
  dateOffset = 0;
  dateRange: DateRange = null;

  info: any = {
    count: 0,
    debits: 0,
    vat: 0
  };

  constructor(
    private transactionsService: TransactionsService,
    private cdr: ChangeDetectorRef,
    private transactionService: TransactionsService,
    private route: ActivatedRoute) {

  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.load();

      if (params.transaction != undefined) {

        this.transactionService.get(params.transaction).subscribe((transaction: Transaction) => {
          this.openTransactionDialog(transaction, 0);
        })
      }
    });
  }

  load() {
    this.isLoading = true;
    let query = {}

    this.dateRange = this.getDateRange();

    query = {
      "status": {
        "$ne": 'ignore'
      },
      "date": { 
        "$gte": this.dateRange.start,
        "$lte": this.dateRange.end
       },
      "$or": [ 
        {"source.account": ACCOUNT.REVENUE}
      ],
      "$and": [
            { "amount": { "$gt": 0 } },
          ]
    };

    this.transactionsService.find(query).subscribe((transactions: Transaction[]) => {
      this.dataSource = new MatTableDataSource<Transaction>(transactions);
      this.cdr.detectChanges();

      this.transactionsService.infoData(query).subscribe(result => {
        this.info = result;
        this.isLoading = false;
      });
    });
  }

  getDateRange() {
    switch (this.dateMode) {
      case DateMode.Weekly:
        return this.getWeekRange(this.dateOffset);
      break;
      case DateMode.Monthly:
        return this.getMonthlyRange(this.dateOffset);
      break;
      case DateMode.Quaterly:
      return this.getQuaterlyRange(this.dateOffset);
      break;
      case DateMode.Yearly:
        return this.getYearlyRange(this.dateOffset);
      break;
    }
  }

  getLabel() {
    switch (this.dateMode) {
      case DateMode.Weekly:
        return [ "Previous Week", "Next Week" ];
      case DateMode.Monthly:
        return [ "Previous Month", "Next Month" ];
      case DateMode.Quaterly:
        return [ "Previous Quater", "Next Quater" ];
      case DateMode.Yearly:
        return [ "Previous Year", "Next Year" ];
    }
  }

  nextDateRange() {
    if (this.dateOffset > 0) {
      this.dateOffset--;
      this.load();
    }
  }

  previousDateRange() {
    this.dateOffset++;
    this.load();
  }

  isSearching = false;
  skipNextSeach = false
  searchQuery: string = null;
  search(query: string) {
    if (!this.isSearching) {
      this.dataSource = new MatTableDataSource<Transaction>();
      this.isSearching = true;
      this.searchQuery = query;
    }

    this.transactionsService.search(query, this.dateRange, [ACCOUNT.REVENUE]).subscribe((result: any) => {
      this.isSearching = true;

      console.log(result)
      if (!this.skipNextSeach) {
        this.dataSource = new MatTableDataSource<Transaction>(result.transactions);
        this.info = result.info;
        this.cdr.detectChanges();
      } else {
        this.skipNextSeach = false;
      }
    })
  }

  searchCancelled() {
    this.skipNextSeach = true;
    this.isSearching = false;
    this.searchQuery = null;
    this.load();
  }

  getMonthlyRange(monthOffset: number) {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() - monthOffset;
  
    // Calculate the year and month, accounting for offset
    const targetYear = year + Math.floor(month / 12);
    const targetMonth = (month % 12 + 12) % 12; // Ensure the month is in the range 0-11
  
    // Calculate the number of days in the target month
    const numDays = new Date(targetYear, targetMonth + 1, 0).getDate();
  
    // Calculate the start and end dates of the month
    const startDate = new Date(targetYear, targetMonth, 1);
    const endDate = new Date(targetYear, targetMonth, numDays);
  
    return {
      start: startDate,
      end: endDate,
    };
  }

  getYearlyRange(yearOffset: number) {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const targetYear = currentYear - yearOffset;
  
    // Calculate the start and end dates of the target year
    const startDate = new Date(targetYear, 0, 1); // January 1st
    const endDate = new Date(targetYear, 11, 31); // December 31st
  
    return {
      start: startDate,
      end: endDate,
    };
  }
  

  getQuaterlyRange(dateOffset: number) {
    const date = new Date();

    const currentMonth = date.getMonth() + (1 - ((dateOffset % 4) * 3))
    const currentYear = date.getFullYear() - Math.floor(((((date.getMonth() + (1 - ((dateOffset) * 3))) / 12)-1)*-1));

    const currentQuarter = {
       1: 3, // January
       2: 3, // February
       3: 3, // March
    
       4: 4, // April
       5: 4, // May
       6: 4, // June
    
       7: 1, // July
       8: 1, // August
       9: 1, // September
    
       10: 2, // October
       11: 2, // November
       12: 2, // December
    }[currentMonth]
    const quater = {
       // First Quater
       1: {
        start: new Date(currentYear + "-07-01T00:00:00+10:00"),
        end:   new Date(currentYear + "-09-30T23:23:59+10:00")
       },
       2: {
        start: new Date(currentYear + "-10-01T00:00:00+10:00"),
        end:   new Date(currentYear + "-12-30T23:23:59+10:00")
       },
       3: {
        start: new Date(currentYear + "-01-01T00:00:00+10:00"),
        end:   new Date(currentYear + "-03-31T23:23:59+10:00")
       },    
       4: {
        start: new Date(currentYear + "-04-01T00:00:00+10:00"),
        end:   new Date(currentYear + "-06-31T23:23:59+10:00")
       }
    }[currentQuarter]
    
      return quater;
  }

  getWeekRange(weekOffset: number) {
    let date = new Date(new Date().getTime() - (1000 * 60 * 60 * 24 * 7 * weekOffset))

    let first = setToMonday(date);
    first.setHours(0,0,0,0);

    let last = new Date(first.getTime());
    last.setDate(first.getDate() + 6); // last day is the first day + 6
    last.setHours(23,59,59);

    return {
      start: first,
      end: last
    }
  }

  openTransactionDialog(transaction: Transaction, index: number) {
    window.history.pushState({}, '',`/expenses/${transaction.source.sha1}`);

    this.transactionService.openTransactionDialog(TransactionType.Expense, transaction.source.sha1, index, this.dataSource, (r)=> {
      if (this.isSearching) {
        this.search(this.searchQuery);
      } else {
        this.load();
      }
      window.history.pushState({}, '', '/expenses')
    });
  }

  switchToWeekly() {
    this.dateOffset = 0;
    this.dateMode = DateMode.Weekly;
    this.load();
  }

  switchToMonthly() {
    this.dateOffset = 0;
    this.dateMode = DateMode.Monthly;
    this.load();
  }

  switchToQuaterly() {
    this.dateOffset = 0;
    this.dateMode = DateMode.Quaterly;
    this.load();
  }

  switchToYearly() {
    this.dateOffset = 0;
    this.dateMode = DateMode.Yearly;
    this.load();
  }

  openTaxFiguresDialog() {
    this.transactionService.openExpensesTaxFiguresDialog(this.dateRange, (r)=> {
      
    });
  }

}

function setToMonday( date: Date ): Date {
  var day = date.getDay() || 7;  
  if( day !== 1 ) 
      date.setHours(-24 * (day - 1)); 
  return date;
}